import { AuctionType } from '../../../../../auctions/types';

export enum CommercialCattleSalesFilter {
  DirectFeeder = 'direct-feeder',
  PresortFeeder = 'presort-feeder',
  AllCommercial = 'all-commercial'
}

export enum PurebredSpecialtySalesFilter {
  LivePurebred = 'live-purebred',
  TimedFarmGate = 'timed-farmgate',
  Events = 'events',
  AllPurebredSpecialty = 'all-purebred-specialty'
}

export type SaleTypeFilterValue = CommercialCattleSalesFilter | PurebredSpecialtySalesFilter;

export const SaleTypeFilterGroups = {
  COMMERCIAL_CATTLE_SALES: 'Commercial Cattle Sales',
  PUREBRED_SPECIALTY_SALES: 'Purebred & Specialty Sales'
} as const;

export type SaleTypeFilterGroup = (typeof SaleTypeFilterGroups)[keyof typeof SaleTypeFilterGroups];

export type SaleTypeFilterOption = {
  Value: SaleTypeFilterValue;
  Label: string;
  Group: SaleTypeFilterGroup;
};

// Mapping from frontend filters to backend AuctionType arrays
export const filterToAuctionTypeMap: Record<SaleTypeFilterValue, AuctionType[]> = {
  [CommercialCattleSalesFilter.DirectFeeder]: [AuctionType.Direct],
  [CommercialCattleSalesFilter.PresortFeeder]: [AuctionType.Presort],
  [CommercialCattleSalesFilter.AllCommercial]: [AuctionType.Direct, AuctionType.Presort],
  [PurebredSpecialtySalesFilter.LivePurebred]: [AuctionType.Purebred],
  [PurebredSpecialtySalesFilter.TimedFarmGate]: [AuctionType.Timed],
  [PurebredSpecialtySalesFilter.Events]: [AuctionType.Event],
  [PurebredSpecialtySalesFilter.AllPurebredSpecialty]: [AuctionType.Purebred, AuctionType.Timed, AuctionType.Event]
};

// Static filter options with groups
export const saleTypeFilterOptions: SaleTypeFilterOption[] = [
  {
    Value: CommercialCattleSalesFilter.DirectFeeder,
    Label: 'Direct Feeder Sales',
    Group: SaleTypeFilterGroups.COMMERCIAL_CATTLE_SALES
  },
  {
    Value: CommercialCattleSalesFilter.PresortFeeder,
    Label: 'Presort Feeder Sales',
    Group: SaleTypeFilterGroups.COMMERCIAL_CATTLE_SALES
  },
  {
    Value: CommercialCattleSalesFilter.AllCommercial,
    Label: 'All Commercial Cattle Sales',
    Group: SaleTypeFilterGroups.COMMERCIAL_CATTLE_SALES
  },
  {
    Value: PurebredSpecialtySalesFilter.LivePurebred,
    Label: 'Live Purebred & Specialty Sales',
    Group: SaleTypeFilterGroups.PUREBRED_SPECIALTY_SALES
  },
  {
    Value: PurebredSpecialtySalesFilter.TimedFarmGate,
    Label: 'Timed FarmGate Sales',
    Group: SaleTypeFilterGroups.PUREBRED_SPECIALTY_SALES
  },
  {
    Value: PurebredSpecialtySalesFilter.Events,
    Label: 'Events',
    Group: SaleTypeFilterGroups.PUREBRED_SPECIALTY_SALES
  },
  {
    Value: PurebredSpecialtySalesFilter.AllPurebredSpecialty,
    Label: 'All Purebred & Specialty Sales',
    Group: SaleTypeFilterGroups.PUREBRED_SPECIALTY_SALES
  }
];
